import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import type { AnnouncementCardProps } from './type'

export const AnnouncementCard = ({
  title,
  targetDate,
}: AnnouncementCardProps) => {
  const { t } = useTranslation()

  return (
    <div className={clsx('tw-text-sm')}>
      <div className={clsx('tw-text-gray-600')}>{targetDate}</div>
      <div className={clsx('tw-font-bold')}>{title}</div>
      <div className={clsx('tw-text-primary-500 tw-underline')}>
        {t('announcement.viewDetails')}
      </div>
    </div>
  )
}
